module.exports = __webpack_public_path__ + "static/media/a-emporter.24ccf134.png";